// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"4f1c6060","537":"527b122d","787":"cda612ba"}[chunkId] + ".chunk.js";
};